import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiServicesService } from '../services/api-services.service';

import { MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { mergeMap, take } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-create-bene-connection',
  templateUrl: './create-bene-connection.component.html',
  styleUrls: ['./create-bene-connection.component.scss']
})
export class CreateBeneConnectionComponent implements OnInit {
  createBeneConnection: FormGroup;
  isSubmitted = false;
  @ViewChild('inviteBene', { static: false }) inviteBene: NgForm;
  beneficiaryID: any;
  userType: string;

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private apiService: ApiServicesService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    protected store: Store<any>) { 
      this.createForm(); 
      this.userType = sessionStorage.getItem('userTypeRole');
    }

  private createForm() {
    this.createBeneConnection = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      communicationEmailId: ['', [Validators.required, Validators.email]],
      note: ''
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.createBeneConnection.controls; }

  ngOnInit(): void {
    this.createBeneConnection.patchValue({
      firstName: this.config.data.fname + ' ' + this.config.data.lname
    });
  }

  createBeneConnectionForm() {
    const payload = {
      note: this.createBeneConnection.value.note,
      emailId: this.createBeneConnection.value.communicationEmailId
    };

    if (this.userType === "Petitioner") { 

      this.apiService.getPetitionerBeneficiaryConnectionStatus(parseInt(sessionStorage.getItem('companyId')), this.config.data.id)
      .pipe(
        take(1),
        mergeMap((response) => {
          if (response && response.data && !response.data.isConnected) {
            return this.apiService
              .sendBeneficiaryConnectionInvite(parseInt(sessionStorage.getItem('companyId')), this.config.data.id, payload);
          } else {
            this.toastr.info(response.message);
            return EMPTY;
          }
        }))
      .subscribe(result => {
        if (result && result.status === 200) {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
          this.toastr.success(result.message, 'Success');
          this.ref.close();
        }
      });
      
    } else{

      this.apiService.getAttorneyBeneficiaryConnectionStatus(parseInt(sessionStorage.getItem('companyId')), this.config.data.id)
      .pipe(
        take(1),
        mergeMap((response) => {
          if (response && response.data && !response.data.isConnected) {
            return this.apiService
              .sendBeneficiaryConnectionInvite(parseInt(sessionStorage.getItem('companyId')), this.config.data.id, payload);
          } else {
            this.toastr.info(response.message);
            return EMPTY;
          }
        }))
      .subscribe(result => {
        if (result && result.status === 200) {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
          this.toastr.success(result.message, 'Success');
          this.ref.close();
        }
      });

    }



  }
}
